module.exports = __webpack_public_path__ + "img/icon-gift-coin.ef250905.png";